import React from "react";

import { trpc } from "@blis/trpc/react";

import type { TPanel, TTestSpec, TTubeWithFields } from "../types";

interface LookupCacheValues {
  loading: boolean;
  tubeById(id: number): TTubeWithFields | undefined;
  testById(id: number): TTestSpec | undefined;
  panelById(id: number): TPanel | undefined;
  panels: readonly TPanel[];
}

const LookupCacheContext = React.createContext({} as LookupCacheValues);

export function LookupCacheProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data, isLoading } = trpc.static.values.useQuery();

  const tubes = data?.tubes || [];
  const testSpecs = data?.testSpecs || [];
  const panels = data?.panels || [];

  const tubeById = (id: number) => tubes.find((t) => t.id === id);
  const testById = (id: number) => testSpecs.find((t) => t.id === id);
  const panelById = (id: number) => panels.find((p) => p.id === id);

  return (
    <LookupCacheContext.Provider
      value={{ loading: isLoading, tubeById, testById, panelById, panels }}
    >
      {children}
    </LookupCacheContext.Provider>
  );
}

export function useCacheValues() {
  const values = React.useContext(LookupCacheContext);
  if (!values) {
    throw new Error("Must run useCacheValues inside `LookupCacheProvider`");
  }
  return values;
}
